/**
 * Hook to determine if Indeed Pro branding should be enabled
 *
 * @returns true if Pro branding should be shown (badge, theme, etc.)
 *
 * Uses proctor test: js_pro_auto_apply_brand_tst
 * - value === 1: HIDE Pro branding (treatment group - Pro branding disabled)
 * - value !== 1: SHOW Pro branding (control group - Pro branding enabled)
 */
export const useIsProBrandingEnabled = (): boolean => {
    return false;
};
